import React, { useEffect, useState } from "react";
import TongueTwisterForm from "./TongueTwisterForm";
import "./tongueTwister.css";

import {
  fetchAllTwisters,
  deleteTwister,
  publishTwister,
  unpublishTwister
} from "./adminTongueTwisterService";

const AdminTongueTwisterPage = () => {

  const [twisters, setTwisters] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadTwisters();
  }, []);

  const loadTwisters = async () => {

    setLoading(true);

    const response = await fetchAllTwisters();

    if (response.status === 200) {
      setTwisters(response.data.content || []);
    } else {
      alert(response.message || "Failed to load data");
    }

    setLoading(false);
  };

  const handleDelete = async (id) => {

    if (!window.confirm("Delete this item?")) return;

    const res = await deleteTwister(id);

    if (res.status === 204) {
      loadTwisters();
    } else {
      alert(res.message);
    }
  };

  const togglePublish = async (id, status) => {

    const res = status === "PUBLISHED"
      ? await unpublishTwister(id)
      : await publishTwister(id);

    if (res.status === 204) {
      loadTwisters();
    } else {
      alert(res.message);
    }
  };

  const editItem = (item) => {
    setEditing(item);
    setShowForm(true);
  };

  const newItem = () => {
    setEditing(null);
    setShowForm(true);
  };

  const onSaved = () => {
    setShowForm(false);
    loadTwisters();
  };

  return (

    <div className="admin-container">

      <div className="admin-header">
        <h2>Tongue Twister Management</h2>
        <button onClick={newItem}>
          + New Twister
        </button>
      </div>

      {showForm && (
        <TongueTwisterForm
          data={editing}
          onSaved={onSaved}
          onCancel={() => setShowForm(false)}
        />
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="announcement-table">

          <thead>
            <tr>
              <th>Title</th>
              <th>Difficulty</th>
              <th>Language</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>

            {twisters.length === 0 ? (
              <tr>
                <td colSpan="5">No data found</td>
              </tr>
            ) : (
              twisters.map((t) => (
                <tr key={t.id}>

                  <td>{t.title}</td>
                  <td>{t.difficultyLevel}</td>
                  <td>{t.language}</td>
                  <td>
  <span
    className={`status-badge ${
      t.status === "PUBLISHED"
        ? "status-published"
        : "status-draft"
    }`}
  >
    {t.status}
  </span>
</td>

                  <td>

                    <button onClick={() => editItem(t)}>
                      Edit
                    </button>

                    <button
                      onClick={() => togglePublish(t.id, t.status)}
                    >
                      {t.status === "PUBLISHED"
                        ? "Unpublish"
                        : "Publish"}
                    </button>

                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(t.id)}
                    >
                      Delete
                    </button>

                  </td>

                </tr>
              ))
            )}

          </tbody>

        </table>
      )}

    </div>
  );
};

export default AdminTongueTwisterPage;